export default "__VITE_ASSET__e02e6745__"